module.exports = __webpack_public_path__ + "img/minus.6e5dcacf.svg";